import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  AlertTitle,
  Box,
  Chip,
  Typography
} from '@mui/material';

/**
 * InvalidKeysAlert - Warning for invalid keys in content
 * 
 * UX Philosophy:
 * - NO ACTION BUTTONS - User may have intentionally written these
 * - Informational only - "Maybe you meant these as keys, maybe not"
 * - Non-blocking - User can continue editing
 * 
 * Example:
 * Content: "{{Müşteri Adı}} {{T.C.}} {{123}}"
 * → Warning: "3 geçersiz key tespit edildi"
 * → User decides: Delete them OR keep them (not keys, just text)
 */
const InvalidKeysAlert = ({ invalidKeys = [] }) => {
  if (invalidKeys.length === 0) return null;
  
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>
        {invalidKeys.length} geçersiz key tespit edildi
      </AlertTitle>
      <Typography variant="body2" gutterBottom>
        Aşağıdaki key'ler isimlendirme kurallarına uymuyor. 
        Eğer bunlar key değilse (normal metin), görmezden gelebilirsiniz.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
        {invalidKeys.map((key) => (
          <Chip
            key={key}
            label={`{{${key}}}`}
            size="small"
            color="warning"
            variant="outlined"
            sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}
          />
        ))}
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        ℹ️ Key kuralları: Harf ile başlamalı, sadece harf/rakam/alt çizgi, Türkçe karakter yasak
      </Typography>
    </Alert>
  );
};

InvalidKeysAlert.propTypes = {
  invalidKeys: PropTypes.arrayOf(PropTypes.string)
};

InvalidKeysAlert.defaultProps = {
  invalidKeys: []
};

export default InvalidKeysAlert;

